import 'dotenv/config';
import path from 'node:path';
import { cosmiconfig } from 'cosmiconfig';
import { loadConfig } from 'tsconfig-paths';

import { resolvedConfigSchema, RawConfig, rawConfigSchema } from '../schema';
import { z } from 'zod';

const explorer = cosmiconfig('multiverse-config', {
  searchPlaces: ['multiverse.config.json'],
});

const getMultiverseUIConfig = async (cwd: string) => {
  let config: z.infer<typeof rawConfigSchema> | null = null;
  try {
    const configResult = await explorer.search(cwd);
    if (configResult) {
      const rawConfig = rawConfigSchema.parse(configResult.config);
      config = rawConfig;
    }
  } catch (err) {
    throw new Error(
      `Invalid configuration detected in your multiverse.config.json. To fix this, try deleting the file and run the init command again.`
    );
  }
  if (!config) return config;
  return await resolveConfigPaths(cwd, config);
};

export const resolveConfigPaths = async (cwd: string, config: RawConfig) => {
  // Read tsconfig.json.
  const tsOrJsConfig = loadConfig(cwd);

  if (tsOrJsConfig.resultType === 'failed') {
    throw new Error(
      `Failed to load jsconfig.json. ${tsOrJsConfig.message ?? ''}`.trim()
    );
  }

  return resolvedConfigSchema.parse({
    ...config,
    resolvedPaths: {
      tailwindConfig: path.resolve(
        cwd,
        config.tailwind.version === 'v3' ? config.tailwind.config : ''
      ),
      tailwindCss: path.resolve(cwd, config.tailwind.css),
      utilities: path.resolve(cwd, config.directory.utilities),
      components: path.resolve(cwd, config.directory.components),
    },
  });
};

export default getMultiverseUIConfig;
